import {Box, Container, css, FormControlLabel, styled} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components/CTAButtonFixed';

const StyledContainer = styled(Container)`
	padding: 16px;
	max-width: 916px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px 32px 32px;
	}
`;

const StyledBox = styled(Box)`
	margin-bottom: 98px;
	margin-top: auto;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-bottom: 0px;
	}
`;

const CustomCTAButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
	align-self: flex-end;
`;

const StyledCheckbox = styled(FormControlLabel)`
	margin: 0;
	font-size: 0.75rem;
	border-radius: 8px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 8px 0px 8px 8px;
	}

	${({theme}) => css`
		background-color: ${theme.palette.background.paper};
		color: ${theme.colors.light.text.primary};
	`}
`;

export {StyledContainer, StyledBox, CustomCTAButtonFixedAction, StyledCheckbox};
